import React from "react";
import {Logo} from '../../../helpers/Logo';

export default () => (
  <Logo className="logo--merchant" text="Referral" />
);
